import React from 'react'
import { MainContent } from 'styles/algolia'
import { Layout } from '../components/styles'
import Header from './Header'
import Breadcrumb from 'components/SA/Breadcrumb'
import CollectionsList from '../components/collections/CollectionsList'
import NewThisWeekList from '../components/newThisweek/NewThisweekList'
import NavTabs from '../components/navPanel/NavTabs'
import LoadMoreButton from '../components/LoadMoreButton'
import NewThisWeekHeader from './NewThisWeekHeader'
import { HOME_TOOLTIP, ALL_ARTWORKS_TOOLTIP } from '../helpers/constants'
import styles from './Layout.module.scss'

export default (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <>
      <Layout>
        <div className={styles.breadcrumbContainer}>
          <Breadcrumb
            items={[
              {
                name: 'Home',
                title: HOME_TOOLTIP,
                url: '/',
              },
              {
                name: 'All Artworks',
                title: ALL_ARTWORKS_TOOLTIP,
                url: '/all',
              },
            ]}
          />
        </div>

        <Header />

        <NewThisWeekHeader />

        <NewThisWeekList />

        <NavTabs />

        <MainContent>
          <CollectionsList />
        </MainContent>

        <LoadMoreButton />
      </Layout>
    </>
  )
}
